/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-05-18 15:47:45
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\ueditor\service\insertEcharts\insertEchartsCtrl.js
 * @Description: 
 */
'use strict';
angular.module('insetEchartsModule', []).controller('insetEchartsCtrl', [
    '$scope',
    '$sce',
    '$modalInstance',
    '$timeout',
    function($scope, $sce, $modalInstance, $timeout) {
        setIframeHeight();
        initStatus();


        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                iframeSrc: $sce.trustAsResourceUrl('/datavisual/#/NewChart'),
            };
        }

        // 回调函数
        /**
         * [receiveMessageFromIframePage description]
         * @param {[object]} [event] [description] 事件对象
         * @return  {[type]}  [return description]
         */
        function receiveMessageFromIframePage (event) {
            $modalInstance.close(event.data.msg.imgurl);
        }

        // 监听message事件
        window.addEventListener('message', receiveMessageFromIframePage, false);
      
    
        /**
         * [setIframeHeight] 控制iframe的高度
         * @return {[type]} [description]
         */
        function setIframeHeight() {
            $timeout(function() {
                var hei = window.innerHeight - 145;
                $('.insert-echarts .body .iframeBody').css({ height: hei });
            });
        }

        /**
         * [cancel 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    },
]);
